module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/16.b1b151a5.jpg";